import React from "react";

interface ChatUnavailableModalProps {
  onClose: () => void;
}

export const ChatUnavailableModal: React.FC<ChatUnavailableModalProps> = ({ onClose }) => (
  <div
    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/45 p-5"
    onClick={onClose}
  >
    <div
      className="relative w-full max-w-[380px] rounded-2xl bg-white p-7 shadow-[0_12px_40px_rgba(0,0,0,0.2)]"
      onClick={e => e.stopPropagation()}
    >
      <button
        onClick={onClose}
        className="absolute right-5 top-5 text-gray-400 hover:text-gray-600"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: 18,
          lineHeight: 1,
        }}
      >
        ×
      </button>

      <div className="mb-3 flex items-center gap-2">
        <span className="material-icons !text-[20px] text-[#f5a623]">error</span>
        <span className="text-[16px] font-bold text-[#111215]">Chat unavailable</span>
      </div>

      <p className="mb-6 text-[13px] leading-[1.6] text-[#444]">
        This dashboard owner&apos;s trial has expired, so AI chat is currently unavailable.
      </p>

      <button
        onClick={onClose}
        className="w-full rounded bg-[#3053ff] py-3 text-[13px] font-semibold text-white hover:opacity-90"
      >
        Got it
      </button>
    </div>
  </div>
);
